import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../Context/LanguageContext";
import "./Hero.css";

// --- Import your 3 images ---
import Hero1 from "../Assets/technology_banner.png";
import Hero2 from "../Assets/technology_banner2.png";
import Hero3 from "../Assets/technology_banner3.png";

const Hero = () => {
    const { t } = useLanguage();

    // === Image Slider State ===
    const images = [Hero1, Hero2, Hero3];
    const [currentIndex, setCurrentIndex] = useState(0);

    // === Auto Change Every 3 Seconds ===
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [images.length]); // Added dependency array item for clean practice

    return (
        <div className="hero">
            <div className="hero-left">
                <div>
                    <h2>{t.title}</h2>

                    <p>{t.line_1}</p>
                    <br />

                    <p>{t.line_2}</p>
                    <br />

                    <p>{t.line_3}</p>
                    <br /><br />

                    <a><Link to="/contact">{t.cta}</Link></a>
                </div>
            </div>

            {/* === Right Side Auto-Slider === */}
            <div className="hero-right">
                <img
                    key={currentIndex} 
                    src={images[currentIndex]}
                    alt="Technology Solutions"
                    className="hero-slider-image"
                />
            </div>
        </div>
    );
};

export default Hero;